@if (fetchInProgress() || this.productsCount()) {
  <em-empty-state
    [iconName]="'download'"
    (ctaClicked)="startProductImporting()"
  >
    <div title>{{ 'PROGRESS_ACTION_RUNNING' | translate }}</div>
    <div description>
      {{ 'DISCLAIMER_IMPORT_PRODUCTS_IN_PROGRESS' | translate }}
      <div class="mt-4">
        <em-three-dots-loading></em-three-dots-loading>
      </div>
    </div>
  </em-empty-state>
} @else if (lastFetchFail()) {
  <em-empty-state
    [cta]="'SHARED_LABEL_MANGE_PRODUCT_SOURCES' | translate"
    [secondaryCta]="'PRODUCT_FLOW_IMPORT_RETRY' | translate"
    [iconName]="'warning'"
    (ctaClicked)="toDataSources()"
    (secodnaryCtaClicked)="reImport()"
  >
    <div title>{{ 'NO_PRODUCTS_AVAILABLE' | translate }}</div>
    <div description>
      {{ 'FETCH_FAILED_NO_PRODUCTS_DESC' | translate }}
      <a
        class="block"
        href="mailto:customer-service@repricing.com"
        target="_blank"
        >{{ 'SERVICE_FACEBOOK_UNAVAILABLE_ACTION' | translate }}</a
      >
    </div>
  </em-empty-state>
} @else if (lastFetchSuccess()) {
  <em-empty-state
    [cta]="'SHARED_LABEL_MANGE_PRODUCT_SOURCES' | translate"
    [secondaryCta]="'PRODUCT_FLOW_IMPORT_RETRY' | translate"
    [iconName]="'warning'"
    (ctaClicked)="toDataSources()"
    (secodnaryCtaClicked)="reImport()"
  >
    <div title>{{ 'NO_PRODUCTS_AVAILABLE' | translate }}</div>
    <div description>
      {{ 'FETCH_SUCCESS_BUT_NO_PRODUCTS_DESC' | translate }}
      <a
        class="block"
        href="mailto:customer-service@repricing.com"
        target="_blank"
        >{{ 'SERVICE_FACEBOOK_UNAVAILABLE_ACTION' | translate }}</a
      >
    </div>
  </em-empty-state>
} @else {
  <em-empty-state
    [cta]="'SHOPSYSTEM_STATUS_IMPORT_ACTION' | translate"
    [iconName]="'package_2'"
    (ctaClicked)="startProductImporting()"
  >
    <div title>{{ 'NO_PRODUCTS_AVAILABLE' | translate }}</div>
    <div description>
      {{ 'SHARED_DESC_IMPORT_PRODUCTS_TO_UNLOCK_FEATUES' | translate }}
    </div>
  </em-empty-state>
}
